import { useFormContext } from "react-hook-form";
// Mui
import { IconButton, Stack, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export default function DialogSearchInput() {
  const { register, setValue, watch } = useFormContext();
  
  const handleClearClick = () => {
    const value = '';
    setValue('keyword', value);
  }

  const keywordValue = watch('keyword');

  return (
    <Stack width="100%" direction="row" spacing={2} alignItems="center">
      <input type="submit" style={{ opacity: 0, position: 'absolute', visibility: 'hidden', pointerEvents: 'none', top: -9999, left: -9999 }} />
      <SearchIcon color="disabled" fontSize="small" />
      <InputBase
        {...register('keyword')}
        placeholder="Search"
        autoFocus
        fullWidth
      />
      {keywordValue ? (
        <IconButton size="small" onClick={handleClearClick}>
          <ClearIcon fontSize="small" />
        </IconButton>
      ) : null}
    </Stack>
  );
}
